module.exports = __webpack_public_path__ + "static/img/recommend-list-1.2f566e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-1.png
// module id = 0W3B
// module chunks = 1